import { ChangeDetectionStrategy, Component,Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from 'src/app/models/question.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { DisplayByTypeDirective } from '../../../question/display-by-type.directive';
import { SvgIconComponent } from 'angular-svg-icon';
import { AutoResizeDirective } from 'src/app/directves/autoresize.directive';
import { EQuestionType } from 'src/app/models/questionType.model';
import { ChooseRecipientsComponent } from "../../../../../users/components/choose-recipients/choose-recipients.component";

@Component({
    selector: 'que-display-title-question',
    imports: [CommonModule, TranslateDirective, TranslatePipe, DisplayByTypeDirective, SvgIconComponent, AutoResizeDirective, ChooseRecipientsComponent],
    templateUrl: './display-title-question.component.html',
    styleUrls: ['./display-title-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisplayTitleQuestionComponent {
  @Input() question!: Question;
  @Input() isPreview=false;
  color$=inject(QuestionnaireStore).mainColor$;
  equestionType = EQuestionType;
}
